import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconParagraph: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconParagraph"><Path fillRule="evenodd" clipRule="evenodd" d="M7.75 4C5.54086 4 3.75 5.79086 3.75 8C3.75 10.2091 5.54086 12 7.75 12H9V4H7.75ZM10 4V20.5C10 20.7761 9.77614 21 9.5 21C9.22386 21 9 20.7761 9 20.5V13H7.75C4.98858 13 2.75 10.7614 2.75 8C2.75 5.23858 4.98858 3 7.75 3H20.5C20.7761 3 21 3.22386 21 3.5C21 3.77614 20.7761 4 20.5 4H16V20.5775C16 20.8536 15.7761 21.0775 15.5 21.0775C15.2239 21.0775 15 20.8536 15 20.5775V4H10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconParagraph;
